export default __webpack_public_path__ + "static/media/media.afb68641.png";